import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'showLoaderState',
  initialState: {
    isLoading : false
  },
  reducers: {
    addState(state, action) {
      state.isLoading = action.payload;
    },
  },
});

export { actions as showLoaderStateActions };
export { reducer as showLoaderStateReducer };